import { render, staticRenderFns } from "./ModalController.vue?vue&type=template&id=bd5b2b20&"
import script from "./ModalController.vue?vue&type=script&lang=js&"
export * from "./ModalController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports